import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

// Attendre que le DOM soit chargé
document.addEventListener('DOMContentLoaded', function() {
    const featuresElement = document.querySelector('#brand-features .swiper');
    
    if (featuresElement) {
        const featuresSwiperInit = new Swiper(featuresElement, {
            modules: [Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 1000,
                disableOnInteraction: false,
            }
        });
    }
});